import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Svg = styled.svg`
  transition: all 250ms ease-in-out;
  svg,
  g,
  polygon {
    fill: ${props =>
      props.colorTheme === "light"
        ? props => props.theme.white
        : props => props.theme.black};
  }

  &:hover {
    g,
    polygon {
      fill: ${props => props.theme.red};
    }
  }
`

export const DesktopLogo = ({ theme, isScrolled, ...props }) => {
  return (
    <Svg
      width={isScrolled ? "66px" : "132px"}
      height={isScrolled ? "83px" : "165px"}
      viewBox="0 0 132 165"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      colorTheme={theme}
      {...props}
    >
      <title>Logo/Desktop/White</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <polygon id="path-1" points="0 165 132 165 132 0 0 0" />
      </defs>
      <g
        id="Desktop-+-Mobile"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="A14_Desktop-Artist-Profile"
          transform="translate(-41.000000, -39.000000)"
        >
          <g
            id="Logo/Desktop/White"
            transform="translate(41.000000, 39.000000)"
          >
            <g id="Logo" transform="translate(0.000000, 0.000000)">
              <path
                d="M89.3702882,60.8403107 L86.2794531,53.7026056 C81.9341833,43.6722876 75.0777531,38.4626096 67.1593496,38.4626096 C58.2740576,38.4626096 50.0658167,46.3726698 50.0658167,62.191646 C50.0658167,77.1421519 59.4322616,87.8487096 73.7259424,87.8487096 C82.6100887,87.8487096 89.2740576,83.9903669 93.32949,79.2635538 L97,80.6137449 C93.8129342,88.6199204 84.0592757,103.378196 67.6416482,102.99259 C47.3610495,102.99259 35,87.0774987 35,67.5924104 C35,47.8189762 48.2305617,32 68.607391,32 C77.7825203,32 83.4796009,33.2540758 88.0184775,33.2540758 L93.32949,33.2540758 L93.32949,60.8403107 L89.3702882,60.8403107 Z"
                id="Fill-1"
              />
              <g id="Clip-4" />
              <polygon
                id="Fill-3"
                points="1.31838984e-13 144 131 144 131 129 1.31838984e-13 129"
              />
              <polygon
                id="Fill-5"
                points="1.31838984e-13 3 131 3 131 -2.84217094e-14 1.31838984e-13 -2.84217094e-14"
              />
              {!isScrolled && (
                <>
                  <path
                    d="M9.64595028,157.280843 L9.09793504,155.97484 C8.32718524,154.136889 7.10986367,153.184382 5.70619487,153.184382 C4.12941059,153.184382 2.67281476,154.631328 2.67281476,157.528631 C2.67281476,160.265667 4.33560545,162.226376 6.87058941,162.226376 C8.44627105,162.226376 9.62830794,161.519384 10.348336,160.654399 L11,160.90105 C10.4343424,162.36732 8.70318765,165.06912 5.79109864,164.998648 C2.19316359,164.998648 -1.16085852e-13,162.085432 -1.16085852e-13,158.51751 C-1.16085852e-13,154.897303 2.34753408,152 5.96200882,152 C7.59061748,152 8.60064154,152.230739 9.40667602,152.230739 L10.348336,152.230739 L10.348336,157.280843 L9.64595028,157.280843 Z"
                    id="Fill-6"
                  />
                  <path
                    d="M16.7876712,163 C17.4890411,163 18,162.306574 18,160.483737 C18,157.854325 17.1287671,157 16.2123288,157 C15.509589,157 15,157.693426 15,159.516263 C15,162.144637 15.8726027,163 16.7876712,163 M16.5367977,165 C13.8066473,165 12,163.064613 12,160.429837 C12,157.883747 13.8814297,156 16.4810076,156 C19.1375626,156 21,157.779344 21,160.447798 C21,163.028689 19.100765,165 16.5367977,165"
                    id="Fill-7"
                  />
                  <polygon
                    id="Fill-8"
                    points="24.9190953 163.736837 26 165 21 165 22.1320139 163.736837 22.1320139 153.445607 21 152.181282 24.9190953 152"
                  />
                  <path
                    d="M36.0844193,163.54347 L37,164.770794 L33.3558074,164.946933 L33.4963173,163.33233 L33.4611898,163.33233 C32.6509915,164.472714 31.7002833,165 30.7677054,165 C29.1303116,165 27.8453258,163.894618 27.8453258,162.263079 L27.8453258,157.403463 L27,156.175009 L30.7495751,156 L30.7495751,162.754234 L33.18017,162.754234 L33.18017,157.403463 L32.1229462,156.175009 L36.0844193,156 L36.0844193,163.54347 Z"
                    id="Fill-9"
                  />
                  <path
                    d="M41.3800423,157.609981 L41.4151685,157.609981 C42.0667019,156.608061 42.9992446,156 44.3374377,156 C45.5169965,156 46.2036561,156.553935 46.6965554,157.431478 C47.3129627,156.53666 48.1401269,156 49.5667019,156 C51.2210304,156 52.1898323,157.127447 52.1898323,158.790403 L52.1898323,163.748177 L53,165 L48.4743919,165 L49.2845596,163.748177 L49.2845596,158.11094 L47.0319535,158.11094 L47.0319535,163.748177 L47.7707358,165 L43.404895,165 L44.1266808,163.748177 L44.1266808,158.11094 L41.8729415,158.11094 L41.8729415,163.748177 L42.7001058,165 L38,165 L38.9676688,163.748177 L38.9676688,157.484453 L38,156.23263 L41.5205469,156.052975 L41.3800423,157.609981 Z"
                    id="Fill-10"
                  />
                  <path
                    d="M57,164 L57.7799228,164 C58.7992278,164 60,163.528745 60,161.189474 C60,158.848988 59.2998713,158 57.6396396,158 L57,158 L57,164 Z M57.2132216,156.522434 C57.7195065,156.221091 58.4073557,155.848977 59.3838454,155.848977 C61.6801676,155.848977 63,157.728949 63,160.105453 C63,162.818685 61.4450652,165 58.5877561,165 C56.4532123,165 55.2602421,164.397313 54.2302142,163.794626 L54.2302142,153.2419 L53,152.178067 L57.1771415,152 L57.1771415,156.522434 L57.2132216,156.522434 Z"
                    id="Fill-11"
                  />
                  <path
                    d="M65.5080906,155 C64.6699029,155 64,154.329018 64,153.508091 C64,152.653722 64.6699029,152 65.5080906,152 C66.3462783,152 67,152.653722 67,153.508091 C67,154.329018 66.3462783,155 65.5080906,155 L65.5080906,155 Z M66.9228435,163.740602 L68,165 L63.0162549,165 L64.1443433,163.740602 L64.1443433,157.43898 L63,156.179583 L66.9228435,156 L66.9228435,163.740602 Z"
                    id="Fill-12"
                  />
                  <path
                    d="M74,161 L73.7907107,161.02046 C72.8181309,161.118926 72,161.87468 72,163.047315 C72,163.742967 72.4006715,164 72.887521,164 C73.2691662,164 73.6351427,163.762148 74,163.445013 L74,161 Z M72.4342572,157.115879 L72.4342572,158.982787 L69.6241955,158.982787 C69.5508998,158.860422 69.5142519,158.651615 69.5142519,158.302482 C69.5142519,156.715105 72.0665966,156 73.3894654,156 C76.0340208,156 77.1736503,157.151802 77.1736503,158.493327 L77.1736503,163.726955 L78,164.773232 L74.1980822,164.94836 L74.4002364,163.639391 L74.3635886,163.639391 C73.4816761,164.617188 72.7463549,165 71.717851,165 C70.4138973,165 69,164.564426 69,162.785082 C69,161.005738 70.6704322,159.820257 73.3705504,159.575527 L74.1425194,159.522764 L74.1425194,157.115879 L72.4342572,157.115879 Z"
                    id="Fill-13"
                  />
                  <path
                    d="M86,160.980497 L84.4923391,156 L83,161 L86,160.980497 Z M82.3933518,163.267485 L84.0631579,165 L80,165 L81.1878116,163.267485 L85.0448753,152.693899 L86.765651,152 L91.2421053,163.891101 L92,165 L86.5761773,165 L88.1429363,163.90895 L87.0759003,161.152321 L83.133518,161.170171 L82.3933518,163.267485 Z"
                    id="Fill-14"
                  />
                  <path
                    d="M95.9991325,163.748177 L97.4528105,165 L92,165 L92.9424011,163.748177 L92.9424011,157.485605 L92,156.23263 L95.3773421,156.054127 L95.1878904,158.397697 L95.2631853,158.397697 C95.8861901,157.163148 96.8298057,156 98.1316794,156 C98.3769951,156 98.8676266,156.089827 99,156.23263 L99,159.114012 L95.9991325,159.114012 L95.9991325,163.748177 Z"
                    id="Fill-15"
                  />
                  <path
                    d="M104.043974,157.284897 L104.043974,163.061785 L106,163.061785 C105.442335,164.377574 104.249051,165 103.205677,165 C101.88287,165 100.970218,164.200229 100.970218,162.84897 L100.970218,157.053776 L100,156.822654 L100,156.058352 L104.043974,153 L104.043974,156.058352 L105.796122,156.058352 L105.796122,157.284897 L104.043974,157.284897 Z"
                    id="Fill-16"
                  />
                  <path
                    d="M108.508091,155 C107.669903,155 107,154.329018 107,153.508091 C107,152.653722 107.669903,152 108.508091,152 C109.346278,152 110,152.653722 110,153.508091 C110,154.329018 109.346278,155 108.508091,155 L108.508091,155 Z M109.923077,163.740602 L111,165 L106.017335,165 L107.145179,163.740602 L107.145179,157.43898 L106,156.179583 L109.923077,156 L109.923077,163.740602 Z"
                    id="Fill-17"
                  />
                  <path
                    d="M113.922133,157.69178 C113.922133,159.173631 118,159.034427 118,162.488711 C118,164.16253 116.523733,165 115.265067,165 C114.187733,165 113.392,164.773232 112.696533,164.773232 L112.050133,164.773232 L112.050133,161.459274 L112.7296,161.459274 L113.0272,162.052014 C113.706667,163.412623 114.5856,163.866159 115.3472,163.866159 C115.844267,163.866159 116.059733,163.656231 116.059733,163.30822 C116.059733,161.843208 112,161.825246 112,158.52925 C112,156.819509 113.2928,156 114.833067,156 C115.861333,156 116.2752,156.226768 116.789333,156.226768 L117.418667,156.226768 L117.418667,159.279157 L116.7232,159.279157 L116.4576,158.738057 C115.8784,157.569415 115.248,157.029437 114.667733,157.029437 C114.187733,157.029437 113.922133,157.256206 113.922133,157.69178"
                    id="Fill-18"
                  />
                  <path
                    d="M123.043974,157.284897 L123.043974,163.061785 L125,163.061785 C124.442335,164.377574 123.249051,165 122.205677,165 C120.88287,165 119.970218,164.200229 119.970218,162.84897 L119.970218,157.053776 L119,156.822654 L119,156.058352 L123.043974,153 L123.043974,156.058352 L124.796122,156.058352 L124.796122,157.284897 L123.043974,157.284897 Z"
                    id="Fill-19"
                  />
                  <path
                    d="M127.922475,157.69178 C127.922475,159.173631 132,159.034427 132,162.488711 C132,164.16253 130.524538,165 129.265647,165 C128.188122,165 127.392248,164.773232 126.69559,164.773232 L126.050142,164.773232 L126.050142,161.459274 L126.72973,161.459274 L127.027383,162.052014 C127.70697,163.412623 128.58606,163.866159 129.347795,163.866159 C129.84495,163.866159 130.060455,163.656231 130.060455,163.30822 C130.060455,161.843208 126,161.825246 126,158.52925 C126,156.819509 127.29303,156 128.834637,156 C129.86202,156 130.277027,156.226768 130.790185,156.226768 L131.41963,156.226768 L131.41963,159.279157 L130.72404,159.279157 L130.458393,158.738057 C129.878023,157.569415 129.248578,157.029437 128.668208,157.029437 C128.188122,157.029437 127.922475,157.256206 127.922475,157.69178"
                    id="Fill-20"
                  />
                </>
              )}
            </g>
          </g>
        </g>
      </g>
    </Svg>
  )
}

DesktopLogo.propTypes = {
  theme: PropTypes.oneOf(["dark", "light"]),
}
